module.exports = __webpack_public_path__ + "img/ai-floor-plan.a89ec94e.svg";